/**
 * Checks if a customer is eligible for trial based on available offers
 * This matches the exact logic that was in getCustomer.js
 * @param {Object} state - Redux state
 * @returns {boolean} - true if eligible or if offers data not available, false if not eligible
 */
export default state => {
  let isEligibleForTrial = false;
  if (state.offers?.data) {
    const availableOffers = Object.values(state.offers.data).flat();
    isEligibleForTrial = availableOffers.some(offer => offer.descriptors && offer.descriptors.includes('trial'));
  } else {
    isEligibleForTrial = true;
  }

  return isEligibleForTrial;
};
